import React from 'react'
import Icon from 'decorators/Icon'

// eslint-disable-next-line react/prop-types
const IconTwitter = ({ t, className, height, width, fill }) => (
  <svg className={className} width={width} height={height} viewBox='0 0 39 32'>
    <title>{t('Twitter')}</title>
    <g fill='none' fillRule='evenodd'>
      <path d='M34.2983727 7.75194074C34.7959182 18.8109037 26.5681 31.1463111 12.0116455 31.1463111c-4.42000005 0-8.53981823-1.3108148-12.01200005-3.538963 4.15409091.498963 8.30818182-.6613333 11.60663635-3.2485925-3.43672725-.069926-6.32981816-2.3442963-7.32490907-5.4660741 1.22672727.2322963 2.44163636.1742222 3.54072727-.128-3.77236364-.7656296-6.37590909-4.1659259-6.28254545-7.8103704 1.053.5807408 2.2560909.941037 3.55136363.9872593C1.59628182 9.59727407.60119091 4.97860741 2.6611 1.43845926c3.86572727 4.75851852 9.6400909 7.89214815 16.1542727 8.21688889-1.1345454-4.92088889 2.5810909-9.6557037 7.6369091-9.6557037 2.2572727 0 4.2935455.9517037 5.7282727 2.48414814 1.7821819-.34844444 3.4603637-1.00977778 4.9766364-1.91525926-.5909091 1.84533334-1.8294545 3.38844445-3.4485454 4.352 1.5848181-.18607407 3.1010909-.61511111 4.5003636-1.23022222-1.0518182 1.57866667-2.3837273 2.95940741-3.9106364 4.06162963'
        fill={fill} />
    </g>
  </svg>
)

export default Icon(IconTwitter)
